import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {createStructuredSelector} from 'reselect'
import selectors from '../../store/selectors'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { dropdownItemClick }from 'App/actions'


class Dropdown extends Component {
  handleSelect = (e) => {
    this.props.handleButtonClick(e.target)
  }

  render() {
    const { dropdownOptions:options} = this.props
    if (options.length === 0) { return null }

    return (
      <Container>
        <Select onChange={this.handleSelect}>
          <option selected disabled>Choose option...</option>
          {options.map(option => {
            return <option key={option} value={option} tabIndex="0">{option}</option>
          })}
        </Select>
      </Container>
    )
  }
}

Dropdown.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleButtonClick: PropTypes.func.isRequired
}

const mapStateToProps = createStructuredSelector({
  dropdownOptions: selectors.selectDropdownOptions,
})

const mapDispatchToProps = dispatch => ({
  handleButtonClick: button => dispatch(dropdownItemClick(button)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dropdown)

const Container = styled.div`
  height: 7.5rem;
  display: flex;
  justify-content: center;
  padding: 1rem;
`

const Select = styled.select`
  width: max-content;
  background-color: ${props => props.theme.primaryColor};
  padding: .5rem;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.primaryColor};
  color: ${props => props.theme.secondaryColor};
  font-weight: bold;
  padding: 1rem;
  cursor: pointer;
  outline: 0;
  opacity: 1;
  font-size: 14px;
  overflow: auto;
  height: fit-content;
`


// WEBPACK FOOTER //
// ./src/ChatWidget/components/Dropdown/index.js